<template>
  <div>
    <div class="body-wrapper">
      <!-- <div>
        <page-header heading="Featured Programs"
          desc="Click on the tabs below to select your respective program."></page-header>
      </div> -->
      <section class="popular-exams-section online-course-details exams-grid p-0" id="popularExamsSection">


        <div :class="{ 'sticky-tab': isHeaderSticky }" class="ebookFiltersWrap">

          <!-- :class="{ 'sticky-tab': isHeaderSticky } -->
          <div id="header" class="tabs-slider featured-program-categories" v-if="categories.length">
            <div ref="header" class="featured-program-wrap mainCategories e-book-filter  d-flex justify-content-center">
              <div class="featured-program-categories-inside">
                <!-- <SsrCarousel :slides-per-page="null" :responsive="[{ maxWidth: 425, slidesPerPage: 2 }]"> -->
                <div v-for="cat in categories" :key="cat.ProgramCategory.ProgramCategoryId"
                  @click="selectCategory(cat.ProgramCategory.ProgramCategoryId)" class="exam-tabs-head upperHeadings"
                  :class="{
                    featuredProgramMainHead:
                      selectedCategoryId === cat.ProgramCategory.ProgramCategoryId,
                  }">
                  {{ cat.ProgramCategory.Category }}
                </div>
                <!-- </SsrCarousel> -->
              </div>
            </div>
          </div>



          <!-- ===== Dynamic rows rendered in flow order ===== -->
          <div v-for="node in displayFlowNodes" :key="'row-' + node">
            <!-- Programs Row -->
            <div v-if="node === 'Program' && programs.length"
              class="tabs-slider subCategories featured-program-categories dynamic-row">
              <div class="chips">
                <div v-for="prog in programs" :key="prog.AcademicProgram.AcademicProgramId"
                  @click="selectProgram(prog.AcademicProgram.AcademicProgramId)" class="chips-inner">
                  <div class="exam-tabs-head " :class="{
                    featuredProgramMainHead:
                      selectedProgramId === prog.AcademicProgram.AcademicProgramId,
                  }">
                    {{ prog.AcademicProgram.AcademicProgramName }}
                  </div>
                </div>
              </div>
            </div>


            <!-- Boards Row -->
            <div v-else-if="node === 'Board' && boards.length"
              class="tabs-slider dynamic-row boards-row boardSelection">
              <div class="chips">
                <div v-for="b in boards" :key="b.Board.BoardId" @click="selectBoard(b.Board.BoardId)"
                  class="chips-inner">
                  <div class="exam-tabs-head lowerHeadings"
                    :class="{ featuredProgramSubHead: selectedBoardId === b.Board.BoardId }">
                    {{ b.Board.BoardName }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Groups Row (optional) -->
            <!-- <div v-else-if="node === 'Group' && groups.length" class="tabs-slider dynamic-row groups-row">
          <div class="chips">
            <div v-for="g in groups" :key="g.Group.CourseGroupId" @click="selectGroup(g.Group.CourseGroupId)"
              class="chips-inner">
              <div class="exam-tabs-head lowerHeadings"
                :class="{ featuredProgramSubHead: selectedGroupId === g.Group.CourseGroupId }">
                {{ g.Group.CourseGroupDisplayName }}
              </div>
            </div>
          </div>
            </div> -->
          </div>


        </div>
        <div v-if="isHeaderSticky" style="height: 100px;"></div>
        <!-- ===== COURSE LIST ===== -->
        <div class="container mt-4">
          <skeleton-loader id="ebookCoursesLoader" :count="3" :showEmptyTemplate="true" :defaultLoadingProp="true">
            <template #default="{ isLoading }">
              <div class="row" v-if="courseList.length">
                <div class="col-lg-4 col-md-6 mb-40" v-for="(course, idx) in courseList" :key="idx">
                  <!-- Conditionally render courseCard or ebooksCard based on LearningType -->
                  <course-card
                    v-if="!course.LearningType || course.LearningType.Value === appConstants.enums.learningType.Course"
                    :model="course" />
                  <ebooks-card v-else-if="course.LearningType.Value === appConstants.enums.learningType.Ebook"
                    :model="course" />
                </div>
              </div>
              <div class="text-center my-5" v-else-if="isLoading && !courseList.length">
                <noEbookTemplate />
              </div>
              <div class="load-more">
                <a v-if="canCoursesLoadMore && isLoading" @click="loadMore" href="javascript:void(0)">
                  <i class="far fa-chevron-down"></i>
                </a>
              </div>
            </template>
          </skeleton-loader>
        </div>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  programCategories as programCategoriesStoreKeys,
  classCourses as classCoursesStoreKeys,
} from "../store/keys";
import pageHeader from "./pageHeader";
import Footer from "../layout/landing/appFooter";
import courseCard from "./courseCard.vue";
import ebooksCard from "./ebooks-card.vue";
import skeletonLoader from "./skeletonLoader/index.vue";
import noEbookTemplate from "./noEbookTemplate.vue";
import { appConstants } from "../common/constants";

export default {
  components: {
    pageHeader,
    Footer,
    courseCard,
    ebooksCard,
    skeletonLoader,
    noEbookTemplate,
  },
  metaInfo: {
    title: "eBooks | KIPS VIRTUAL",
    titleTemplate: "",
    meta: [
      {
        name: "description",
        content: "Discover KIPS Virtual e-book programs and online courses tailored for exam preparation, academic success, and flexible learning.",
      },
      {
        name: "keywords",
        content: "KIPS Virtual, e-book programs, online learning, exam prep, study materials, digital education",
      },
      {
        property: "og:title",
        content: "eBooks | KIPS VIRTUAL",
      },
      {
        property: "og:description",
        content: "Discover KIPS Virtual e-book programs and online courses tailored for exam preparation, academic success, and flexible learning.",
      },
      {
        property: "og:type",
        content: "website",
      },
      {
        name: "twitter:card",
        content: "summary_large_image",
      },
      {
        name: "twitter:title",
        content: "eBooks | KIPS VIRTUAL",
      },
      {
        name: "twitter:description",
        content: "Discover KIPS Virtual e-book programs and online courses tailored for exam preparation, academic success, and flexible learning.",
      },
    ],
    link: [
      {
        rel: "canonical",
        href: "https://kipsvirtual.com/ebookPrograms",
      },
    ],
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  data() {
    return {
      // Selections
      selectedCategoryId: null,
      selectedProgramId: null,
      selectedBoardId: null,
      selectedGroupId: null,

      // Pagination for courses
      coursePaging: {
        pageNumber: 1,
        pageSize: 12,
      },

      // UI helpers
      isHeaderSticky: false,

      // Constants for template access
      appConstants: appConstants,
    };
  },
  mounted() {
    // Reset store to ensure fresh data when navigating from other routes
    this.reset_ProgramCategories();
    this.reset_ClassCourses();

    // Load program categories, then set initial category
    this.get_ProgramCategories({
      forceRefresh: true, // Force fresh data fetch
      config: {
        loader: {
          show: true,
          id: "ebookCoursesLoader",
        },
      },
    }).then(() => {
      if (this.categories.length) {
        this.selectCategory(this.categories[0].ProgramCategory.ProgramCategoryId);
      }
    });

    // Sticky header handler
    window.addEventListener("scroll", () => {
      this.scrollY = Math.round(window.scrollY);
      if (this.$refs.header) {
        this.headerTop = document
          .getElementById("popularExamsSection")
          .offsetTop;
        if (this.scrollY > this.headerTop + 100) {
          this.isHeaderSticky = true;
          document.body.classList.add("exam-body");
        } else {
          this.isHeaderSticky = false;
          document.body.classList.remove("exam-body");
        }
      }
    });
  },
  computed: {
    ...mapGetters(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.getters),
    ...mapGetters(classCoursesStoreKeys.namespace, classCoursesStoreKeys.getters),

    /* ===== Convenience collections based on selection ===== */
    // Categories filtered to include only those program category records that are marked for E-Books
    categories() {
      // Keep only those records where LearningTypeFilter contains the Ebook enum value (2)
      const ebookRecords = this.programCategories.filter(
        (rec) =>
          Array.isArray(rec.LearningTypeFilter) &&
          rec.LearningTypeFilter.includes(this.appConstants.enums.learningType.Ebook)
      );

      // Return unique categories based on ProgramCategoryId
      return ebookRecords.filter((_, index, self) => {
        return (
          index ===
          self.findIndex(
            (c) =>
              c.ProgramCategory.ProgramCategoryId ===
              _.ProgramCategory.ProgramCategoryId
          )
        );
      });
    },
    // Programs list according to current category
    programs() {
      if (!this.selectedCategoryId) return [];
      const groupId = this.isNodeBefore("Group", "Program") ? this.selectedGroupId || null : null;
      const boardId = this.isNodeBefore("Board", "Program") ? this.selectedBoardId || null : null;

      // Filter records then constrain to ebook learning type
      const filtered = (this.filteredRecords(
        this.selectedCategoryId,
        null,
        boardId,
        groupId
      ) || []).filter(
        (rec) =>
          Array.isArray(rec.LearningTypeFilter) &&
          rec.LearningTypeFilter.includes(this.appConstants.enums.learningType.Ebook)
      );
      const unique = [
        ...new Set(
          filtered
            .filter((o) => o.AcademicProgram)
            .map((o) => o.AcademicProgram.AcademicProgramId)
        ),
      ].map((id) =>
        filtered.find(
          (o) => o.AcademicProgram && o.AcademicProgram.AcademicProgramId === id
        )
      );
      return unique;
    },
    // Boards list according to current selections
    boards() {
      if (!this.selectedCategoryId) return [];
      if (!this.flowNodes.includes("Board")) return [];

      const programId = this.isNodeBefore("Program", "Board") ? this.selectedProgramId || null : null;
      const groupId = this.isNodeBefore("Group", "Board") ? this.selectedGroupId || null : null;

      const filtered = (this.filteredRecords(
        this.selectedCategoryId,
        programId,
        null,
        groupId
      ) || []).filter(
        (rec) =>
          Array.isArray(rec.LearningTypeFilter) &&
          rec.LearningTypeFilter.includes(this.appConstants.enums.learningType.Ebook)
      );
      const unique = [
        ...new Set(
          filtered.filter((o) => o.Board).map((o) => o.Board.BoardId)
        ),
      ].map((id) =>
        filtered.find((o) => o.Board && o.Board.BoardId === id)
      );
      return unique;
    },
    flowNodes() {
      // Find a record for the currently selected category that is marked for E-Books
      const rec = this.programCategories.find(
        (c) =>
          c.ProgramCategory.ProgramCategoryId === this.selectedCategoryId &&
          Array.isArray(c.LearningTypeFilter) &&
          c.LearningTypeFilter.includes(this.appConstants.enums.learningType.Ebook)
      );
      return rec ? rec.ProgramCategoryFlow.map((f) => f.NodeKey) : [];
    },
    // Show all flow nodes again (Group is optional but visible)
    displayFlowNodes() {
      return this.flowNodes;
    },
    // Groups list (optional filtering)
    groups() {
      if (!this.selectedCategoryId) return [];
      if (!this.flowNodes.includes("Group")) return [];

      const progId = this.isNodeBefore("Program", "Group") ? this.selectedProgramId || null : null;
      const boardId = this.isNodeBefore("Board", "Group") ? this.selectedBoardId || null : null;

      const filtered = (this.filteredRecords(
        this.selectedCategoryId,
        progId,
        boardId,
        null
      ) || []).filter(
        (rec) =>
          Array.isArray(rec.LearningTypeFilter) &&
          rec.LearningTypeFilter.includes(this.appConstants.enums.learningType.Ebook)
      );
      const unique = [
        ...new Set(
          filtered.filter((o) => o.Group).map((o) => o.Group.CourseGroupId)
        ),
      ].map((id) =>
        filtered.find((o) => o.Group && o.Group.CourseGroupId === id)
      );
      return unique;
    },
    // Helper to check order in flow
    isNodeBefore() {
      return (a, b) => {
        return this.flowNodes.indexOf(a) < this.flowNodes.indexOf(b);
      };
    },
  },
  methods: {
    ...mapActions(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.actions),
    ...mapActions(classCoursesStoreKeys.namespace, classCoursesStoreKeys.actions),

    /* ===== Selection Handlers ===== */
    autoSelectNext(currentNode) {
      const idx = this.flowNodes.indexOf(currentNode);
      const nextNode = this.flowNodes[idx + 1];

      if (!nextNode || nextNode === "Course") {
        // Reached Course level
        this.fetchCourses();
        return;
      }

      switch (nextNode) {
        case "Program":
          if (!this.selectedProgramId && this.programs.length) {
            // Select first program then deeper selections handled by its own call
            this.selectProgram(this.programs[0].AcademicProgram.AcademicProgramId);
          }
          break;
        case "Board":
          if (this.boards.length) {
            if (!this.selectedBoardId) {
              this.selectBoard(this.boards[0].Board.BoardId);
            }
          } else {
            // No board options available – treat as satisfied and move ahead
            this.fetchCourses();
          }
          break;
        // case "Group":
        //   if (!this.selectedGroupId && this.groups.length) {
        //     this.selectGroup(this.groups[0].Group.CourseGroupId);
        //   } else {
        //     this.fetchCourses();
        //   }
        // break;
        default:
          this.fetchCourses();
      }
    },
    selectCategory(catId) {
      if (this.selectedCategoryId === catId) return;
      this.selectedCategoryId = catId;
      // Reset subsequent selections
      this.selectedProgramId = null;
      this.selectedBoardId = null;
      this.selectedGroupId = null;
      this.coursePaging.pageNumber = 1;
      // Auto select based on first node of flow (only if single option)
      this.$nextTick(() => {
        // const firstNode = this.flowNodes[0];
        let firstNode = this.flowNodes[0];
        if (firstNode === "Group") {
          firstNode = this.flowNodes[1]; // If first is Group, use next node
        }

        switch (firstNode) {
          case "Program":
            if (this.programs.length) {
              this.selectProgram(this.programs[0].AcademicProgram.AcademicProgramId);
            }
            break;
          case "Board":
            if (this.boards.length) {
              this.selectBoard(this.boards[0].Board.BoardId);
            }
            break;
          // case "Group":
          //   if (this.groups.length) {
          //     this.selectGroup(this.groups[0].Group.CourseGroupId);
          //   } else {
          //     // If no group, directly fetch courses
          //     this.fetchCourses();
          //   }
          // break;
          default:
            this.fetchCourses();
        }
      });
    },
    selectProgram(progId) {
      if (this.selectedProgramId === progId) return;
      // Keep earlier selections (e.g., Group) but reset downstream ones (Board)
      this.clearSelectionsAfter("Program");
      this.selectedProgramId = progId;
      this.coursePaging.pageNumber = 1;
      this.autoSelectNext("Program");
    },
    selectBoard(boardId) {
      if (this.selectedBoardId === boardId) return;
      this.clearSelectionsAfter("Board");
      this.selectedBoardId = boardId;
      this.coursePaging.pageNumber = 1;
      this.autoSelectNext("Board");
    },
    selectGroup(groupId) {
      if (this.selectedGroupId === groupId) return;
      this.clearSelectionsAfter("Group");
      this.selectedGroupId = groupId;
      this.coursePaging.pageNumber = 1;
      this.autoSelectNext("Group");
    },

    /* ===== Helpers ===== */
    getFlowNodes(categoryId) {
      const rec = this.programCategories.find(
        (c) => c.ProgramCategory.ProgramCategoryId === categoryId
      );
      return rec ? rec.ProgramCategoryFlow.map((f) => f.NodeKey) : [];
    },
    isReadyForCourses() {
      // Group is optional - only check nodes before Group in flow
      const nodes = this.displayFlowNodes.filter((n) => n !== "Course" && n !== "Group");
      const conditions = {
        Program: !!this.selectedProgramId,
        Board: this.boards.length === 0 || !!this.selectedBoardId, // Board considered satisfied if no board options
      };
      return nodes.every((n) => conditions[n]);
    },
    fetchCourses(pagingMode = null) {
      if (!this.isReadyForCourses()) return;
      const payload = {
        ProgramCategoryId: this.selectedCategoryId,
        AcademicProgramId: this.selectedProgramId,
        BoardId: this.selectedBoardId,
        // Only add CourseGroupId when user has picked one
        ...(this.selectedGroupId && { CourseGroupId: this.selectedGroupId }),
        PageNumber: this.coursePaging.pageNumber,
        PageSize: this.coursePaging.pageSize,
        // ApplyDefaultTagFilter: true,
        SubscriptionType: appConstants.enums.subscriptionType.All,
        LearningType: appConstants.enums.learningType.Ebook,
      };

      this.get_ClassCourses({
        data: payload,
        config: {
          loader: {
            show: true,
            id: "ebookCoursesLoader",
          },
        },
        pagingMode,
      }).then((resp) => {
        this.coursePaging.pageNumber = resp.PageNumber;
      }).catch((error) => {
        console.error(" Course fetch error:", error);
      });
    },
    loadMore() {
      this.coursePaging.pageNumber++;
      this.fetchCourses(appConstants.enums.pagingMode.loadMore);
    },
    courseSubscriptionType() {
      // For e-book listing we use 'All' subscription type unless future requirement dictates otherwise
      return appConstants.enums.subscriptionType.All;
    },
    /* Clear selections for all nodes that appear AFTER the given node in the flow */
    clearSelectionsAfter(nodeKey) {
      const startIdx = this.flowNodes.indexOf(nodeKey);
      if (startIdx === -1) return;
      for (let i = startIdx + 1; i < this.flowNodes.length; i++) {
        const nk = this.flowNodes[i];
        switch (nk) {
          case "Program":
            this.selectedProgramId = null;
            break;
          case "Board":
            this.selectedBoardId = null;
            break;
          case "Group":
            this.selectedGroupId = null;
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
/***** minimal additional styles to match existing design *****/
.second-row,
.boards-row,
.groups-row {
  margin-top: 25px;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.chips-inner {
  margin: 5px;
  cursor: pointer;
}

.load-more {
  text-align: center;
  cursor: pointer;
}

.load-more i {
  background: #fff;
  padding: 9px 10px;
  border-radius: 50%;
  font-size: 17px;
  box-shadow: 0 0 10px 0px #d8d8d8;
}
</style>
